module.exports = __webpack_public_path__ + "static/media/expGreen.63159deb.svg";